module.exports = __webpack_public_path__ + "img/1584657981536281769.55d60f5f.jpg";